/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Icon, Confirm, Loader } from "semantic-ui-react";
import { CustomTable } from "../../../Shared";
import { Event } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./EventCategoryManager.scss";

const eventController = new Event();

export function EventCategoryManager(props) {
  const { reload, onReload } = props;
  const [categories, setCategories] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    loadCategories();
  }, [reload, accessToken]);

  const loadCategories = async () => {
    try {
      const response = await eventController.getEventCategories(accessToken);
      setCategories(response.data);
    } catch (error) {
      console.error("Error loading categories:", error);
      setCategories([]);
    }
  };

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateCategory = (category) => {
    // Esta función ahora será manejada desde el padre
    if (props.onEdit) {
      props.onEdit(category);
    }
  };

  const openDeleteConfirm = (category) => {
    setCategoryToDelete(category);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await eventController.deleteEventCategory(
        accessToken,
        categoryToDelete.id
      );
      onReload();
      onOpenCloseConfirm();
      setCategoryToDelete(null);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  // Configuración de la tabla
  const tableConfig = {
    headers: [
      "Orden",
      "Nombre",
      "Descripción",
      "Color",
      "Icono",
      "Acciones",
    ],
    columnWidths: ["8%", "15%", "25%", "15%", "12%", "10%", "15%"],
    fields: [
      {
        field: "displayOrder",
        dataType: "text",
        align: "center",
      },
      {
        field: "name",
        dataType: "text",
        align: "left",
      },
      {
        field: "description",
        component: "custom",
        render: (row) => row.description || "-",
      },
      {
        field: "color",
        component: "custom",
        render: (row) => (
          <div className="event-category-manager__color">
            <span
              className="event-category-manager__color-box"
              style={{ backgroundColor: row.color }}
            />
            {row.color}
          </div>
        ),
      },
      {
        field: "icon",
        component: "custom",
        align: "center",
        render: (row) =>
          row.icon ? <Icon name={row.icon} size="large" /> : "-",
      },
      {
        buttons: [
          {
            icon: "pencil",
            color: "blue",
            placeholder: "Editar categoría",
            onClick: (row) => openUpdateCategory(row),
          },
          {
            icon: "trash",
            color: "red",
            placeholder: "Eliminar categoría",
            onClick: (row) => openDeleteConfirm(row),
          },
        ],
      },
    ],
  };

  if (categories === null) return <Loader active inline="centered" />;

  return (
    <>
      {categories.length === 0 ? (
        <div className="event-category-manager">
          <div className="event-category-manager__empty">
            <Icon name="tags" size="huge" />
            <p>No hay categorías registradas</p>
            <p className="event-category-manager__empty-hint">
              Usa el botón "Nueva Categoría" para crear la primera
            </p>
          </div>
        </div>
      ) : (
        <CustomTable
          tableConfig={tableConfig}
          data={categories}
          size="small"
          bordered
          hover
          striped
        />
      )}

      <Confirm
        confirmButton="Eliminar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={
          categoryToDelete
            ? `¿Está seguro de eliminar la categoría "${categoryToDelete.name}"? Los eventos asociados no se eliminarán.`
            : ""
        }
        size="mini"
      />
    </>
  );
}
